import { useTranslation } from 'react-i18next';
import { CardWrapper } from '~/components/cards/CardWrapper';

export function MyProductsHeader() {
  const { t } = useTranslation('my-product');

  return (
    <CardWrapper>
      <div className="flex items-start justify-between">
        <div>
          <h1 className="text-2xl font-semibold text-neut-prim mb-1">
            {t('header.title')}
          </h1>
          <p className="text-sm text-neut-sec">{t('header.subtitle')}</p>
        </div>
      </div>
    </CardWrapper>
  );
}
